'use client';
import React from 'react';
import { StockIndicator as SharedStockIndicator } from '@launchstore/shared-puck';
import type { StockIndicatorProps } from '@launchstore/shared-puck';
import { useProduct, useVariantSelection } from '@/lib/hooks/useProduct';
import type { ProductData } from '@launchstore/shared-puck';

const toProductData = (p: any): ProductData | null => {
  if (!p) return null;
  return {
    id: p.id, title: p.title, metadata: p.metadata,
    variants: (p.variants || []).map((v: any) => ({
      id: v.id, sku: v.sku, weight: v.weight, length: v.length, width: v.width, height: v.height,
      inventory_quantity: v.inventory_quantity,
      allow_backorder: v.allow_backorder,
      manage_inventory: v.manage_inventory,
    })),
  };
};

const SharedStockIndicatorRender = (SharedStockIndicator as any).render;

const StockIndicatorImpl: React.FC<StockIndicatorProps> = (props: any) => {
  const { product } = useProduct();
  // Follow the variant the shopper selected so the indicator never shows
  // another variant's stock. Falls back to the first (default) variant
  // when nothing is selected (e.g. selector auto-hidden).
  const { selectedVariant } = useVariantSelection();
  return (
    <SharedStockIndicatorRender
      {...(props as any)}
      product={toProductData(product)}
      selectedVariantId={selectedVariant?.id ?? undefined}
    />
  );
};

export const StockIndicator: any = { ...SharedStockIndicator, render: (props: any) => <StockIndicatorImpl {...props} /> };
export default StockIndicator;
